import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const API_URL = "https://fsys.app.br/5dx/naovendi.php";

const getApiUrl = (dataInicial, dataFinal) => {
  return `${API_URL}?dataInicial=${dataInicial}&dataFinal=${dataFinal}`;
};

const Card = ({ title, value, subtitle, color }) => (
  <div className="border rounded-lg shadow-md p-3 text-center position-relative bg-white w-100">
    <div
      className={`position-absolute top-0 start-50 translate-middle-x w-75 rounded-pill ${color}`}
      style={{ height: "8px" }}
    ></div>
    <h6 className="mt-3 text-muted">{title}</h6>
    <h2 className="fw-bold my-2">{value}</h2>
    <p className="text-muted small">{subtitle}</p>
  </div>
);

const RelatorioNaoVendi = () => {
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [topProduto, setTopProduto] = useState("");
  const [totalPerdido, setTotalPerdido] = useState(0);
  const [agrupado, setAgrupado] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNaoVendi = async () => {
      try {
        setLoading(true);
        const today = new Date();
        const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
        const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        const formatDate = (d) => d.toISOString().split("T")[0];

        const res = await fetch(getApiUrl(formatDate(firstDay), formatDate(lastDay)));
        const json = await res.json();

        setTotalRegistros(json.totalRegistros);
        setTopProduto(json.topProduto);
        setAgrupado(json.agrupado);
        setTotalPerdido(json.totalPerdido);
      } catch (error) {
        console.error("Erro ao buscar dados de não vendi:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchNaoVendi();
  }, []);

  const cards = [
    {
      title: "Total de Registros",
      value: totalRegistros,
      subtitle: "Este mês",
      color: "bg-primary",
    },
    {
      title: "Produto Mais Cadastrado",
      value: topProduto || "-",
      subtitle: "Top 1",
      color: "bg-secondary",
    },
    {
      title: "Total em Perdas",
      value: totalPerdido.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      }),
      subtitle: "Soma de valores",
      color: "bg-danger",
    },
  ];

  return (
    <div className="container mt-4">
      <h3 className="text-center mb-4">Relatório Não Vendi</h3>

      {loading ? (
        <div className="text-center mt-4">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Carregando...</span>
          </div>
          <p className="mt-2">Carregando dados...</p>
        </div>
      ) : (
        <>
          <div className="row g-4">
            {cards.map((card, index) => (
              <div key={index} className="col-md-4 d-flex justify-content-center">
                <Card {...card} />
              </div>
            ))}
          </div>

          <h5 className="mt-5">Registros por Produto e Data</h5>
          <div className="table-responsive">
            <table className="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Produto</th>
                  <th>Data</th>
                  <th>Quantidade</th>
                </tr>
              </thead>
              <tbody>
                {agrupado.length > 0 ? (
                  agrupado.map((item, idx) => (
                    <tr key={idx}>
                      <td>{item.produto}</td>
                      <td>{new Date(item.data).toLocaleDateString("pt-BR")}</td>

                      <td>{item.quantidade}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center">
                      Nenhum registro encontrado.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default RelatorioNaoVendi;
